import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45d00910"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "container",
  class: "container-menu",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  role: "document",
  class: "modal",
  ref: "modal",
  "aria-modal": "true",
  "aria-labelledby": "Deel jouw melati"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "modal-heading" }, "Deel jouw Melati", -1))
const _hoisted_4 = {
  key: 0,
  class: "to-from"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = {
  key: 1,
  class: "text"
}
const _hoisted_9 = { class: "share-buttons" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, {
        name: "fade",
        onAfterLeave: _ctx.leave,
        onAfterEnter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setElements()))
      }, {
        default: _withCtx(() => [
          (_ctx.result && _ctx.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                (_ctx.result.from || _ctx.result.to)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                      _createTextVNode(" Melati "),
                      (_ctx.result.from)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "van " + _toDisplayString(_ctx.result.from), 1))
                        : _createCommentVNode("", true),
                      (_ctx.result.to)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " voor " + _toDisplayString(_ctx.result.to), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.result.title), 1),
                (_ctx.result.text)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.result.text), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("a", {
                    class: "share-button-icon",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShare('facebook'))),
                    "aria-label": "Deel op Facebook",
                    href: _ctx.facebookShare,
                    target: "_blank"
                  }, [
                    _createVNode(_component_Icon, { name: "facebook" })
                  ], 8, _hoisted_10),
                  _createElementVNode("a", {
                    class: "share-button-icon",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onShare('twitter'))),
                    "aria-label": "Deel op Twitter",
                    href: _ctx.twitterShare,
                    target: "_blank",
                    rel: "canonical"
                  }, [
                    _createVNode(_component_Icon, { name: "twitter" })
                  ], 8, _hoisted_11),
                  _createElementVNode("a", {
                    class: "share-button-icon",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onShare('whatsapp'))),
                    "aria-label": "Deel op Whatsapp",
                    href: _ctx.whatsappShare,
                    target: "_blank"
                  }, [
                    _createVNode(_component_Icon, { name: "whatsapp" })
                  ], 8, _hoisted_12),
                  _createElementVNode("a", {
                    class: "share-button-icon",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onShare('email'))),
                    "aria-label": "Deel via email",
                    href: _ctx.emailShare,
                    target: "_blank"
                  }, [
                    _createVNode(_component_Icon, { name: "email" })
                  ], 8, _hoisted_13)
                ]),
                _createElementVNode("button", {
                  class: "close",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [
                  _createVNode(_component_Icon, { name: "close" })
                ])
              ], 512))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onAfterLeave"])
    ], 512)
  ]))
}